<template>
    <div
        v-if="isFetchingCartRecommendations"
        class="row"
    >
        <div
            v-for="(_, itemIndex) in cartRecommendationsLimit"
            :key="itemIndex"
            class="col-6 col-md-4 mb-2"
        >
            <div class="cart-popup-product">
                <div class="cart-popup-product__image-wrapper cart-popup-product__image-wrapper--skeleton">
                </div>
                <div class="cart-popup-product__body">
                    <div class="cart-popup-product__title">
                        <div class="cart-popup-product__title--skeleton"></div>
                        <div class="cart-popup-product__title--skeleton mt-2"></div>
                    </div>
                    <div class="cart-popup-product__rating-wrapper">
                        <div class="cart-popup-product__rating-icon--skeleton"></div>
                        <div class="cart-popup-product__rating-icon--skeleton"></div>
                        <div class="cart-popup-product__rating-icon--skeleton"></div>
                        <div class="cart-popup-product__rating-icon--skeleton"></div>
                        <div class="cart-popup-product__rating-icon--skeleton"></div>
                        <div class="cart-popup-product__rating-amount--skeleton"></div>
                    </div>
                    <div class="row align-items-center mt-auto">
                        <div class="col-6 col-md-7 col-lg-8">
                            <div class="cart-popup-product__variant--skeleton mb-2"></div>
                            <div class="cart-popup-product__price--skeleton"></div>
                        </div>
                        <div class="col-6 col-md-5 col-lg-4">
                            <div class="cart-popup-product__buy-button--skeleton"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div
        v-else
        class="row"
    >
        <a
            v-for="(item, itemIndex) in cartRecommendations"
            :key="itemIndex"
            :href="item.product_url"
            :title="item.title"
            class="col-6 col-md-4 mb-2"
        >
            <div class="cart-popup-product">
                <div class="cart-popup-product__image-wrapper">
                    <img :src="getImageUrlOrFallbackUrl(item.image_url)" :alt="item.title" class="cart-popup-product__image"/>
                </div>
                <div class="cart-popup-product__body">
                    <h5 class="cart-popup-product__title" v-text="item.title"></h5>
                    <div class="cart-popup-product__rating-wrapper">
                        <i v-if="item.rating >= 0.5" class="fas fa-star cart-popup-product__rating-icon"/>
                        <i v-if="item.rating >= 1.5" class="fas fa-star cart-popup-product__rating-icon"/>
                        <i v-if="item.rating >= 2.5" class="fas fa-star cart-popup-product__rating-icon"/>
                        <i v-if="item.rating >= 3.5" class="fas fa-star cart-popup-product__rating-icon"/>
                        <i v-if="item.rating >= 4.5" class="fas fa-star cart-popup-product__rating-icon"/>
                        <span class="cart-popup-product__rating-amount">{{ item.rating_amount }}</span>
                    </div>
                    <div class="row align-items-center mt-auto">
                        <div class="col-6 col-md-7 col-lg-8">
                            <p class="cart-popup-product__variant" v-text="item.variant"></p>
                            <p class="cart-popup-product__price">{{ item.price_formatted }}</p>
                        </div>
                        <div class="d-flex col-6 col-md-5 col-lg-4">
                            <button
                                class="cart-popup-product__add_to_cart product-list__item__add-to-cart-button"
                                :data-id-product="item.id_product"
                                :data-id-product-attribute="item.id_product_combination"
                            >
                                <i class="fas fa-plus"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import BlockCartItem from "./BlockCartItem";
import InputText from "./Address/InputText.vue";

export default {
    name: 'CartRecommendedProducts',
    components: { InputText, BlockCartItem },
    props: {
        isFetchingCartRecommendations: {
            required: true,
            type: Boolean,
        },
        cartRecommendationsLimit: {
            required: true,
            type: Number,
        },
        cartRecommendations: {
            required: true,
            type: Array,
        }
    },
    methods: {
        getImageUrlOrFallbackUrl(imageUrl) {
            if (! imageUrl) {
                return "/img/brekz.jpg";
            }

            return imageUrl;
        },
    },
}
</script>
